"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Grid_1 = require("@material-ui/core/Grid");
const withStyles_1 = require("@material-ui/core/styles/withStyles");
const withTheme_1 = require("@material-ui/core/styles/withTheme");
const classnames_1 = require("classnames");
const _ = require("lodash");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const BonusPoints_1 = require("../../bonus-points/BonusPoints");
const assets_1 = require("../../config/assets");
const config_1 = require("../../config/config");
const InformationDialog_1 = require("../../dialog/InformationDialog");
const InteractiveGameStyle_1 = require("../../earn/jss/InteractiveGameStyle");
const VideoModal_1 = require("../../earn/VideoModal");
const LoadError_1 = require("../../load-error/LoadError");
const RestrictionMessage_1 = require("../../message-alert/RestrictionMessage");
const ReadMore_1 = require("../../read-more/ReadMore");
const SignInWarningMessage_1 = require("../../warning-message/SignInWarningMessage");
const package_1 = require("../../package");
const INITIAL_STATE = {
    launchGame: false,
    loading: false,
    gameCompleted: false,
    isPortrait: false,
    gameType: 'prize',
    launchVideo: false,
    videoPlaying: false
};
class InteractiveGame extends React.Component {
    constructor(props) {
        super(props);
        this.orientationChange = () => {
            this.setState({ isPortrait: true });
        };
        this.onCloseGame = async () => {
            if (this.props.onGameExitHandler) {
                await this.props.onGameExitHandler();
            }
            this.setState({ launchGame: false });
            if (this.props.onClose) {
                await this.props.onClose();
            }
        };
        this.onOpenGame = (gameType) => {
            this.setState({ launchGame: true, loading: true, gameType }, () => {
                this.orientationChange();
            });
            this.props.getGameData(gameType);
            this.registerGame();
        };
        this.registerGame = () => {
            window.addEventListener('message', this.receiveMessage, false);
        };
        this.getGameData = () => {
            const gameData = {
                points: this.props.gamePoints,
                outcome: this.props.gamePoints,
                spinResults: this.props.spinResults ? this.props.spinResults : null,
                gameFace: this.props.digitalRevealTokenDetails
                    ? this.props.digitalRevealTokenDetails.face
                    : null,
                gameConfig: this.props.digitalRevealTokenDetails
                    ? this.props.digitalRevealTokenDetails.gameConfig
                    : null,
                type: this.props.gameType ? this.props.gameType : 'prize',
                hideExitButtons: this.props.gameConfig && this.props.gameConfig.hasOwnProperty('hideExitButtons')
                    ? this.props.gameConfig.hideExitButtons
                    : true
            };
            return gameData;
        };
        this.receiveMessage = async (event) => {
            try {
                const data = JSON.parse(event.data);
                if (!data || data.type !== 'poGame')
                    return;
                switch (data.name) {
                    case 'onGamePauseHandler': {
                        if (this.props.onGamePauseHandler)
                            this.props.onGamePauseHandler();
                        return console.warn('***** onGamePauseHandler');
                    }
                    case 'onGameResumeHandler': {
                        if (this.props.onGameResumeHandler)
                            this.props.onGameResumeHandler();
                        return console.warn('***** onGameResumeHandler');
                    }
                    case 'onGameResultHandler': {
                        if (this.props.onGameResultHandler)
                            this.props.onGameResultHandler(data.data);
                        return console.warn('***** onGameResultHandler ', data.data);
                    }
                    case 'onGameReplayHandler': {
                        this.setState({ loading: true });
                        if (this.props.onGameReplayHandler)
                            await this.props.onGameReplayHandler();
                        this.setState({ loading: false });
                        document.getElementById('game-container').contentWindow.postMessage(JSON.stringify({
                            type: 'poGameParent',
                            name: 'setGameConfig',
                            data: this.getGameData()
                        }), '*');
                        return console.warn('***** onGameReplayHandler');
                    }
                    case 'onGameStartHandler': {
                        if (this.props.onGameStartHandler)
                            this.props.onGameStartHandler();
                        return console.warn('***** onGameStartHandler');
                    }
                    case 'onGameReadyHandler': {
                        if (this.props.onGameReadyHandler)
                            await this.props.onGameReadyHandler();
                        document.getElementById('game-container').contentWindow.postMessage(JSON.stringify({
                            type: 'poGameParent',
                            name: 'setGameConfig',
                            data: this.getGameData()
                        }), '*');
                        return console.warn('***** onGameReadyHandler');
                    }
                    case 'onGameEndHandler': {
                        if (this.props.onGameEndHandler)
                            await this.props.onGameEndHandler();
                        this.setState({ gameCompleted: true });
                        return console.warn('***** onGameEndHandler');
                    }
                    case 'onGameExitHandler': {
                        await this.onCloseGame();
                        return console.warn('***** onGameExitHandler');
                    }
                    case 'onGameErrorHandler': {
                        if (this.props.onGameErrorHandler)
                            this.props.onGameErrorHandler(data.data);
                        return console.warn('***** onGameErrorHandler ', data.data);
                    }
                    default:
                        return;
                }
            }
            catch (_a) { }
        };
        this.renderGameDataDescription = (isRestricted) => {
            var _a, _b;
            const { classes, selectedUserActivity, playForFun, isLoggedIn } = this.props;
            const isDisabledPlayPoint = ((selectedUserActivity === null || selectedUserActivity === void 0 ? void 0 : selectedUserActivity.frequencyCap) &&
                (selectedUserActivity === null || selectedUserActivity === void 0 ? void 0 : selectedUserActivity.frequencyCap.limitReached) &&
                isLoggedIn);
            const extraDataInfo = (_b = (_a = selectedUserActivity === null || selectedUserActivity === void 0 ? void 0 : selectedUserActivity.extraData) === null || _a === void 0 ? void 0 : _a.filter(data => data.key === 'additionalInformation')) === null || _b === void 0 ? void 0 : _b.map(data => data.value.toString()).join('');
            const readMorePops = extraDataInfo
                ? _.unescape(extraDataInfo)
                : _.unescape(selectedUserActivity === null || selectedUserActivity === void 0 ? void 0 : selectedUserActivity.description);
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', width: 'inherit' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.spacing }, { children: (0, jsx_runtime_1.jsx)(ReadMore_1.default, { context: readMorePops }) })), isRestricted && (0, jsx_runtime_1.jsx)(RestrictionMessage_1.default, { handleContactUs: this.props.handleContactUs }), this.props.showSignInWarning && ((0, jsx_runtime_1.jsx)(SignInWarningMessage_1.default, { onClick: this.props.redirectToLogin, text: this.props.signInWarningText })), this.renderPlayForFunButtons(isDisabledPlayPoint, playForFun, isRestricted)] })));
        };
        this.renderPlayForFunButtons = (isDisabledPlayPoint, isPlayForFun, isRestricted) => {
            const { classes, refreshing } = this.props;
            if (isPlayForFun) {
                return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.spacing }, { children: [this.props.limitReached && this.renderLimitReached(), (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ id: "btnPlayPoint", variant: "contained", disabled: isRestricted || this.props.showSignInWarning || refreshing || isDisabledPlayPoint, color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.onOpenGame.bind(this, 'prize'), className: (0, classnames_1.default)(classes.button, 'containedButton') }, { children: "Play for Points" })), (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ id: "btnPlayFun", disabled: this.props.showSignInWarning || refreshing, variant: "contained", color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.onOpenGame.bind(this, 'fun'), className: (0, classnames_1.default)(classes.button, 'containedButton') }, { children: "Play for Fun" }))] })));
            }
            return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.spacing }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ id: "btnPlayGame", disabled: isRestricted || this.props.showSignInWarning || refreshing, variant: "contained", color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.onOpenGame.bind(this, 'prize'), className: (0, classnames_1.default)(classes.button, 'containedButton') }, { children: "Play Game" })) })));
        };
        this.hideSpinner = () => {
            this.setState({
                loading: false
            });
        };
        this.renderLimitReached = () => ((0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'subtitle1', color: 'error' }, { children: this.props.t('error.gameTicketEntry.ticketEntry.ticketClosed') })));
        this.renderBonusEarned = () => {
            var _a, _b;
            const { classes, selectedUserActivity } = this.props;
            return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', width: 'inherit' } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'subtitle1', color: 'error' }, { children: this.props.t('error.gameTicketEntry.ticketEntry.ticketClosed') })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.spacing }, { children: (0, jsx_runtime_1.jsx)(ReadMore_1.default, { context: !!selectedUserActivity ? _.unescape(selectedUserActivity.description) : '' }) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.multiplierDetails, style: { backgroundColor: config_1.config.themeColors.primaryColor.hex() } }, { children: [(0, jsx_runtime_1.jsxs)("span", Object.assign({ style: {
                                    color: config_1.config.themeColors.white.hex(),
                                    fontSize: '3rem',
                                    fontWeight: 800,
                                    padding: '1.5rem 0.25rem'
                                } }, { children: [(_a = this.props.multiplier) === null || _a === void 0 ? void 0 : _a.multiplier, "X\u00A0"] })), (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { color: config_1.config.themeColors.white.hex() } }, { children: (_b = this.props.multiplier) === null || _b === void 0 ? void 0 : _b.description }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.spacing }, { children: (0, jsx_runtime_1.jsx)(core_1.Button, Object.assign({ id: "btnPlayGame", disabled: true, variant: "contained", color: config_1.config.internalConfig.BUTTON_BACKGROUND, className: (0, classnames_1.default)(classes.button, 'containedButton') }, { children: "Play Game" })) })), ' '] })));
        };
        this.renderIframe = () => {
            const { classes, selectedUserActivity, refreshing } = this.props;
            const { isPortrait, loading } = this.state;
            const displaySpinner = refreshing === true || loading === true;
            if (isPortrait) {
                return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [displaySpinner && (0, jsx_runtime_1.jsx)(package_1.AppSpinner, { persistSpinner: true }), refreshing === false && ((0, jsx_runtime_1.jsx)("iframe", { src: this.props.gameUrl, id: 'game-container', allow: "autoplay", scrolling: "no", className: classes.iframe, onLoad: this.hideSpinner, title: selectedUserActivity === null || selectedUserActivity === void 0 ? void 0 : selectedUserActivity.title }))] }));
            }
            return ((0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: 'subtitle1', color: 'error' }, { children: this.props.t('error.interactiveGame.onlyPortraitMode') })));
        };
        this.renderLoadAgain = () => {
            const { loading, gameType } = this.state;
            if (loading) {
                this.hideSpinner();
            }
            return ((0, jsx_runtime_1.jsx)(LoadError_1.default, { onReloadIconPress: this.onOpenGame.bind(this, gameType), text: 'Error loading a game. Please try again.' }));
        };
        this.startVideo = () => {
            const { selectedUserActivity } = this.props;
            if (selectedUserActivity && selectedUserActivity.videoUrl) {
                this.setState({ launchVideo: true });
            }
        };
        this.closeVideo = () => {
            this.setState({ launchVideo: false });
        };
        this.validateIsLimitReached = () => {
            const showBonusEarned = this.props.multiplier &&
                this.props.multiplier.multiplier > 1 &&
                this.props.multiplier.end &&
                new Date(this.props.multiplier.end) >= new Date();
            return this.props.playForFun
                ? this.renderGameDataDescription(this.props.isRestricted || false)
                : showBonusEarned
                    ? this.renderBonusEarned()
                    : this.renderLimitReached();
        };
        this.state = Object.assign({}, INITIAL_STATE);
        window.addEventListener('orientationchange', this.orientationChange);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage);
        window.removeEventListener('orientationchange', this.orientationChange);
    }
    render() {
        if (!this.props.selectedUserActivity)
            return null;
        const { classes, theme, selectedUserActivity, limitReached, t } = this.props;
        const image = (selectedUserActivity === null || selectedUserActivity === void 0 ? void 0 : selectedUserActivity.imageUrl)
            ? selectedUserActivity === null || selectedUserActivity === void 0 ? void 0 : selectedUserActivity.imageUrl
            : assets_1.assets.internalAssets.noImage;
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(InformationDialog_1.default, Object.assign({ open: this.state.launchGame, hideButton: true, onClose: this.onCloseGame, maxWidth: 'lg', noSpaces: true, gameView: true, portraitMode: this.props.portraitMode, disableBackdropClick: true, reducedWidth: true }, { children: !this.props.gamePoints && !this.props.refreshing
                        ? this.renderLoadAgain()
                        : this.renderIframe() })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, item: true, xs: 12, justify: 'center', className: classes.header }, { children: [this.props.renderTitle(), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12, style: { paddingTop: theme.spacing(4) } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.details }, { children: [(0, jsx_runtime_1.jsxs)(core_1.Card, Object.assign({ className: classes.imageCard }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.parentDiv }, { children: [(0, jsx_runtime_1.jsx)(core_1.CardMedia, Object.assign({ image: image, className: (0, classnames_1.default)({
                                                            [classes.headerImage]: true,
                                                            [classes.overlay40]: selectedUserActivity.videoUrl
                                                        }) }, { children: this.props.bonusPoints && this.props.bonusPoints > 0 ? (0, jsx_runtime_1.jsx)(BonusPoints_1.default, {}) : null })), selectedUserActivity.videoUrl && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("img", { src: assets_1.assets.internalAssets.playLogo, color: config_1.config.internalConfig.BUTTON_BACKGROUND, onClick: this.startVideo, className: classes.playIcon, alt: "Play Logo" }), (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h6", className: classes.previewText }, { children: t('reward.watchVideo', 'Watch Video') }))] }))] })), (0, jsx_runtime_1.jsx)(VideoModal_1.default, { launchVideo: this.state.launchVideo, videoUrl: selectedUserActivity.videoUrl, onClose: this.closeVideo })] })), limitReached
                                        ? this.validateIsLimitReached()
                                        : this.renderGameDataDescription(this.props.isRestricted || false)] })) }))] }))] }));
    }
}
exports.default = (0, withTheme_1.default)((0, withStyles_1.default)(InteractiveGameStyle_1.default)((0, react_i18next_1.withTranslation)()(InteractiveGame)));
//# sourceMappingURL=InteractiveGame.js.map